import { TThunkAction } from '../../types/redux';
import { setNewAnswerFormStep } from './stepActionsTypes';
import { ENewAnswerModalStep } from '../../types/newAnswer';
import { dailyrentCreateReply as dailyrentCreateReplyThunk } from '../../services/answers/dailyrentCreateReply';
import { removeAnswerButtonAction } from '../reviews';
import { setAnswerText } from './answerTextActions';
import { trackNewAnswerSuccessfulCreation } from './tracking/trackNewAnswerSuccessfulCreation';
import { getObjectInfo, getObjectRating, getReviewsCount } from '../../selectors/objectInfo';

export const dailyrentCreateReply =
  (reviewId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();
    const objectInfo = getObjectInfo(state);
    const objectId = objectInfo.objectId;
    const text = state.newAnswer.data.answer;
    const rating = getObjectRating(state);
    const reviewsCount = getReviewsCount(state);

    const parameters = {
      reviewId: Number(reviewId),
      text,
    };

    try {
      await dailyrentCreateReplyThunk({ context, parameters });
      trackNewAnswerSuccessfulCreation({ objectId, reviewId, rating, reviewsCount });
      dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Success));
      dispatch(removeAnswerButtonAction(reviewId));
    } catch (e) {
      dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Error));
    } finally {
      dispatch(setAnswerText(''));
    }
  };
